export default __webpack_public_path__ + "static/media/home-banner-03.181bb3af.svg";